import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function initOverlapSection() {
    const panels = document.querySelectorAll(".overlap");
    if (panels) {
        panels.forEach((panel) => {
            ScrollTrigger.create({
                trigger: panel,
                start: () => panel.offsetHeight < window.innerHeight ? "top top" : "bottom bottom", // if it's shorter than the viewport, pin it at the top
                pin: true,
                pinSpacing: false,
            });
        });
    }
}

